import React, { useState } from "react";
import { Table, Card, Button, Modal } from "antd";
import { ExportToExcel } from "../../../utils";

export const CancelProducts = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);



  const cancelledData = data.filter((item) => item.status === "Cancelado");

  const groupItems = (items) => {
    const groupedItemsMap = new Map();

    items.forEach((item) => {
      const key = `${item.category}_${item.brand}_${item.model}`;
      if (groupedItemsMap.has(key)) {
        const existingItem = groupedItemsMap.get(key);
        existingItem.quantity += item.quantity;
      } else {
        groupedItemsMap.set(key, { ...item });
      }
    });

    return Array.from(groupedItemsMap.values());
  };



  const groupedData = cancelledData.reduce((acc, item) => {
    const cancelReason = item.cancelReason || "NO APLICA";
    const foundIndex = acc.findIndex((el) => el.cancelReason === cancelReason);

    const totalItems = item.products.reduce(
      (total, currItem) => total + currItem.quantity,
      0
    );
    const customerName = item.customerName;

    if (foundIndex !== -1) {
      acc[foundIndex].count++;
      acc[foundIndex].totalItems += totalItems;
      acc[foundIndex].items = groupItems([
        ...acc[foundIndex].items,
        ...item.products,
      ]);
    } else {
      acc.push({
        customerName: customerName,
        cancelReason: cancelReason,
        count: 1,
        totalItems: totalItems,
        items: groupItems(item.products),
      });
    }

    return acc;
  }, []);

  const columns = [
    {
      title: "Motivo de cancelacion",
      dataIndex: "cancelReason",
      key: "cancelReason",
    },
    {
      title: "Número de órdenes",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Total de Productos",
      dataIndex: "totalItems",
      key: "totalItems",
    },
    {
      title: "Detalle",
      key: "action",
      render: (text, record) => (
        <Button
          onClick={() => {
            setCurrentItems(record.items);
            setIsModalVisible(true);
          }}
        >
          Ver Detalle
        </Button>
      ),
      width: 200,
    },
  ];

  const itemColumns = [
    {
      title: "Categoría",
      dataIndex: "category",
      key: "category",
      width: 150,
    },
    {
      title: "Marca",
      dataIndex: "brand",
      key: "brand",
    },
    {
      title: "Modelo",
      dataIndex: "model",
      key: "model",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
  ];

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentItems([]);
  };

  const generateExportData = (groupedData) => {
    return groupedData.reduce((acc, group) => {
      group.items.forEach((item) => {
        acc.push({
          Categoría: item.category,
          Marca: item.brand,
          Modelo: item.model,
          Cantidad: item.quantity,
          "Motivo de cancelación": group.cancelReason,
        });
      });

      acc.push({
        Categoría: "Total",
        Marca: "",
        Modelo: "",
        Cantidad: group.totalItems,
        "Motivo de cancelación": group.cancelReason,
        "Número de órdenes": group.count,
      });
      return acc;
    }, []);
  };

  const excelData = generateExportData(groupedData);

  const excelColumns = [
    {
      title: "Categoría",
      dataIndex: "Categoría",
      key: "Categoría",
      width: 150,
    },
    {
      title: "Marca",
      dataIndex: "Marca",
      key: "Marca",
    },
    {
      title: "Modelo",
      dataIndex: "Modelo",
      key: "Modelo",
    },
    {
      title: "Cantidad",
      dataIndex: "Cantidad",
      key: "Cantidad",
    },
    {
      title: "Motivo de cancelación",
      dataIndex: "Motivo de cancelación",
      key: "Motivo de cancelación",
    },
    {
      title: "Número de órdenes",
      dataIndex: "Número de órdenes",
      key: "Número de órdenes",
    },
  ];

  return (
    <Card title="Productos cancelados">
      <div className="overflow-x-auto h-fit">
        <Table
          dataSource={groupedData}
          columns={columns}
          pagination={false}
        />
      </div>
      <Modal
        title="Detalle de Productos"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {currentItems.length > 0 ? (
          <div className="overflow-x-auto h-96">
            <Table
              dataSource={currentItems}
              columns={itemColumns}
              pagination={false}
            />
          </div>
        ) : (
          <p>No hay detalles para mostrar.</p>
        )}
      </Modal>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 10,
          marginRight: 20,
        }}
      >
        <ExportToExcel
          data={excelData}
          columns={excelColumns}
          fileName={"productosCancelados"}
        />
      </div>
    </Card>
  );
};
